/**
 * 商品詳細メディアギャラリー
 * thumbnail_slider かつサムネイル非表示時、PC では is-active 切替でスライドする
 */

const PRODUCT_MEDIA_SELECTOR = "[data-js-product-media]";
const DESKTOP_MEDIA_QUERY = window.matchMedia("(min-width: 750px)");

function getSlides(gallery: Element): HTMLElement[] {
  const viewer = gallery.querySelector("[id^='GalleryViewer']");
  if (!viewer) return [];

  return Array.from(
    viewer.querySelectorAll<HTMLElement>(".product__media-item[data-media-id]"),
  );
}

function getActiveIndex(slides: HTMLElement[]): number {
  const index = slides.findIndex((slide) => slide.classList.contains("is-active"));
  return index >= 0 ? index : 0;
}

function updateControls(
  slides: HTMLElement[],
  activeIndex: number,
  prevButton: HTMLButtonElement | null,
  nextButton: HTMLButtonElement | null,
  counterCurrent: Element | null,
): void {
  if (counterCurrent) {
    counterCurrent.textContent = String(activeIndex + 1);
  }

  prevButton?.toggleAttribute("disabled", activeIndex <= 0);
  nextButton?.toggleAttribute("disabled", activeIndex >= slides.length - 1);
}

function switchSlide(gallery: Element, slides: HTMLElement[], nextIndex: number): void {
  const target = slides[nextIndex];
  if (!target) return;

  const mediaId = target.dataset.mediaId;
  if (!mediaId) return;

  const thumbnailButton = gallery.querySelector<HTMLButtonElement>(
    `[data-target="${mediaId}"] button`,
  );
  if (thumbnailButton) {
    thumbnailButton.click();
    return;
  }

  slides.forEach((slide) => slide.classList.remove("is-active"));
  target.classList.add("is-active");
}

function initProductMediaGallery(root: Element): void {
  if (root.dataset.jsProductMediaInitialized === "true") return;

  const gallery = root.querySelector("media-gallery");
  const viewer = gallery?.querySelector("[id^='GalleryViewer']");
  if (!gallery || !viewer) return;

  const slides = getSlides(gallery);
  if (slides.length < 2) return;

  const prevButton = viewer.querySelector<HTMLButtonElement>('button[name="previous"]');
  const nextButton = viewer.querySelector<HTMLButtonElement>('button[name="next"]');
  const counterCurrent = viewer.querySelector(".slider-counter--current");
  const counterTotal = viewer.querySelector(".slider-counter--total");

  if (counterTotal) {
    counterTotal.textContent = String(slides.length);
  }

  updateControls(slides, getActiveIndex(slides), prevButton, nextButton, counterCurrent);

  const onNavigate = (direction: -1 | 1) => (event: Event) => {
    if (!DESKTOP_MEDIA_QUERY.matches) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentSlides = getSlides(gallery);
    const activeIndex = getActiveIndex(currentSlides);
    const nextIndex = activeIndex + direction;

    if (nextIndex < 0 || nextIndex >= currentSlides.length) return;

    switchSlide(gallery, currentSlides, nextIndex);
    updateControls(currentSlides, nextIndex, prevButton, nextButton, counterCurrent);
  };

  prevButton?.addEventListener("click", onNavigate(-1), true);
  nextButton?.addEventListener("click", onNavigate(1), true);

  root.dataset.jsProductMediaInitialized = "true";
}

export function initProductMediaGalleryAll(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>(PRODUCT_MEDIA_SELECTOR).forEach(initProductMediaGallery);
}
